var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldWood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5624 0L14.9485 0.613731L16.2865 2.77964L18.1607 4.6534L20.3861 6.0502L21 5.43647L15.5624 0ZM15.8063 3.61397L15.1521 4.26808L16.1808 5.29666L14.5492 4.86938L14.0037 5.41629L15.0495 6.46187L13.3914 6.02683L12.8552 6.5645L13.9182 7.62724L12.2337 7.18439L1.07242 18.3448L0 21L2.65124 19.9233L17.3853 5.1926L15.8063 3.61397Z",
    fill: "#FBCF2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldWood);
export default __webpack_public_path__ + "static/media/gold_wood.d8b984408b88d71a6b23a2122f29f45b.svg";
export { ForwardRef as ReactComponent };